import './App.css';
import AppRoutes from './Routes/AppRoutes';
function App() {
  return (
    <div className='dark:bg-gray-700 h-screen overflow-y-scroll'>
      <AppRoutes />
    </div>
  );
}

export default App;
